<template>
	<div class="home" id="home">
        <transition name="product-anim"  enter-active-class="animate__animated animate__backInUp">
            <detail-category 
            v-if="category_selected" 
            :category="category_selected" 
            @closeCategory="category_selected = $event">
            </detail-category>
            <product-detail 
            v-if="product_selected" 
            :product="product_selected"
            @closeProductDetail="product_selected = $event">    
            </product-detail>  
        </transition>
    	<div id="content" v-show="!category_selected && !product_selected">
            <button type="button" class="boton-install-android" @click.prevent="install" v-if="showInstallBanner" > + INSTALAR APP <br><label class="label-install-android"><i class="fas fa-bullhorn i-install-android"></i>Promociones exclusivas (No te ocupa espacio).</label></button>
            <div id="pwa-ios-notify"  class="ios-notify abajo-izquierda" style="display: none !important;">    
                <h3 class="equis"><span aria-hidden="true" id="close" @click="Close()">&times;</span></h3>      
                <label class="info" id="info" >
                Para instalar esta Aplicación: <br>
                1. Presione el icono Compartir <img style="margin-top: -5px;" src="/share1.png"><br>
                2. De click en Agregar a inicio <i class="far fa-plus-square"></i> y luego agregar.<br>  
                </label>
            </div>
    		<div class="portada" id="banner" v-if="!form.status_promo || form.portadas_promo.length == 0">
    			<picture>
                    <source rel="preconnect" alt="portada1"  v-bind:srcset="form.url_images+form.portadas[1]" type="image/webp">
                    <source rel="preconnect" alt="portada2" v-bind:srcset="form.url_images+form.portadas[2]" type="image/jp2">
                    <img rel="preconnect" alt="portada3" v-bind:src="form.url_images+form.portadas[0]">
                </picture>  
    		</div>

            <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel" v-if="form.status_promo && form.portadas_promo.length > 0">
              <ol class="carousel-indicators">
                <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
                <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
              </ol>
              <div class="carousel-inner">
                <div class="carousel-item" v-for="(item, index) in form.portadas_promo" :key="index">
                  <img class ="img-responsive" :src="form.url_images + item.imagenes">
                </div>
              </div>
              <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
              </a>
              <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
              </a>
            </div>

    		<div class="color" v-bind:style="{backgroundColor : form.colorBotones }">
    		<div class="datos-licencia">
    			<h3>{{ form.store.name }}</h3>
    			<label id="direccion"><i class="fa fa-map-marker-alt"></i>{{ form.company.address }}</label>
    			<label id="horario"><i class="far fa-clock"></i>{{ form.store.horario }}</label>
                <div class="detail-cupon">
                    <div class="check-image" v-bind:style="{backgroundColor : form.colorBotones }">
                        <i class="fas fa-check"></i>
                    </div>
                    <div class="input-cupon">
                        <input type="text" placeholder="Buscar...." id="buscar"  v-model="texto" @keyup="search()" autocomplete="off">
                    </div>
                </div> 
    			<!--<input type="text" id="buscar" v-model="texto" @keyup="search()" class="form-control izquierda" placeholder="Buscar...." autocomplete="off"> -->
    		</div>
    		</div>
    		<div class="content-categories" v-bind:style="{backgroundColor : form.colorBotones,cursor: 'pointer' }">
    			<h3>Categorías</h3>
    			<div class="categorias">
    				<div @click="showDetail(category)" class="categoria1" v-for="category in form.categories" v-bind:key="category.id_category" v-bind:id="'card_'+category.id_category">
                        <img v-lazyload :data-src="category.imagen" alt="">
    					<div class="detalle-categoria">
    						<h3 v-bind:style="{color : form.colorBotones}">{{ category.name }}</h3>
    					</div>
    				</div>
    			</div>
                <div class="product-per-category">
                    <div class="single-product" v-for="product in product_list_aux" v-bind:key="product.id" v-bind:id="'product_'+product.id" @click="openDetail(product)">
                        <!--<picture>
                            <source alt="pwebp" v-bind:srcset="url_images+product.galery_images[0]" type="image/webp"/>
                            <source alt="pjp2" v-bind:srcset="url_images+product.galery_images[2]" type="image/jp2"/>
                            <img alt="pjpg" rel="preconnect" v-bind:src="url_images+product.galery_images[1]">   
                        </picture>-->
                        <img alt="pjpg" rel="preconnect" v-lazyload :data-src="url_images+product.galery_images[0]"> 
                        <div class="detail-product">
                            <!--<h4 class="name-category">{{ name_category }}</h4>-->
                            <h4 class="name-product">{{ product.name }}</h4>
                            <h4 class="price">${{ Intl.NumberFormat("de-DE").format(product.value_sale) }}</h4>
                        </div>
                    </div>
                </div>
    		</div>
    	</div>
    </div><!--FIN DEL HOME-->	
</template>

<style scoped>

    @import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');


    body{
        padding: 0;
        margin: 0;
    }

    .white{
        background: #fff !important;
    }

    .product-per-category{
        padding-top: 25px;
        width: 100%;
        padding-left: 10px;
        padding-right: 10px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
    }

    .single-product{
        width: 48%;
        margin-bottom: 10px;
        position: relative;
        box-shadow: 0px 0px 4px 0px rgba(71,70,71,1);
        align-self: center;
    }

    .single-product img{
        width: 100%;
        height: auto;
    }

    .detail-product{
        background: #fff;
        text-align: left;
        padding-top: 10px;
        padding-left: 10px;
        padding-right: 10px;
        border-left: 1px solid #F1F1F1;
        border-right: 1px solid #F1F1F1;
        border-bottom: 1px solid #F1F1F1;
    }

    .name-category{
        font-size: 12px;
        font-weight: 400;
    }

    .name-product{
        font-size: 15px;
        font-weight: 500;
        margin-top: -5px;
    }

    .price{
        font-size: 14px;
        font-weight: 600;
        color: #4FB891;
        margin-top: -2px;
    }

    #carouselExampleIndicators{
        height: 25vh;
    }

    .carousel-inner{
        height: 25vh;
    }

    .carousel-item{
        width: 100%;
        height: 25vh;
    }

    @supports(object-fit: cover){
        .carousel-item img{
          width: 100% !important;
          height: 25vh !important;
          object-fit: cover;
          object-position: center center;
        }
    }

    @media only screen and (min-width: 1280px) and (max-width: 1920px){
        #carouselExampleIndicators{
          height: 50vh;
        }

        .carousel-inner{
          height: 50vh;
        }

        .carousel-item{
          width: 100%;
          height: 50vh;
        }

        @supports(object-fit: cover){
            .carousel-item img{
              width: 100% !important;
              height: 50vh !important;
              object-fit: cover;
              object-position: center center;
            }
        } 
    }


    .ios-notify{      
        background-color: #1D8BFA;
        color: white;     
        width: 90%;
        margin-left: 18px;
        border-radius: 15px;
        position: fixed !important;           
        padding-left: 40px !important;          
        padding-right: 40px !important;
        bottom: 10px;  
        height: 160px;   
        padding-bottom: 40px !important;
        text-align: left;
    }

    .abajo-izquierda:before {
      content: "";
      position: absolute;
      bottom: -15px;
      text-align: center;
      left: 0;
      right: 0;
      margin: auto;
      width: 0;
      height: 0;
      border-width: 25px 25px 0;
      border-style: solid;
      border-color: #1D8BFA transparent transparent;
         
    }
    .equis{
      font-size: 24px;
      font-weight: 600;
      text-align: right !important;
      line-height: 10px;
      padding-top: 15px;
    }
    .info{          
      font-size: 16px;
      font-weight: 600;   
       
    }
    .detail-cupon{
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        border:1.3px solid #b2b2b2;
        padding:3px;
        border-bottom-right-radius: 30px;
        border-bottom-left-radius: 30px;
        border-top-left-radius: 30px;
    }

    .check-image{
        width: 40px;
        height: 40px;
        border-radius:50%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .check-image i{
        color: #fff;
        font-size: 16px;
    }

    .input-cupon{
        width: 75%;
        text-align: center;
    }

    .input-cupon input{
        height: 30px;
        font-size: 17px;
        border:none;
        padding-left: 10px;
    }


    .boton-install-android{
        font-size: 16px;
        background-color: #1D8BFA;
        color: white;
        width: 100%;
        border: none;
        padding-top: 7px;
        font-weight: 500;
    }
    .label-install-android{
        font-size: 14px;
        font-weight: 500;
    }
    .i-install-android{
        margin-right: 0.35rem;
        color:white;
    }
    .portada img{
        width: 100%;
        height: auto;
        border-bottom-left-radius: 35px;
    }

    .datos-licencia{
        background-color: #fff;
        padding-top: 25px;
        padding-bottom: 15px;
        padding-left: 20px;
        padding-right: 20px;
        text-align: left;
        border-bottom-left-radius: 35px;
        /*border-top-right-radius: 35px;*/
    }
    .datos-licencia h3{
        font-size: 22px;
    }

    label#direccion{
        text-align: left;
        font-size: 14px;
        margin-right: 10px;
    }

    label#horario{
        text-align: left;
        font-size: 14px;
    }

    .datos-licencia i:nth-child(1){
        margin-right: 0.30rem;
    }
    .datos-licencia i:nth-child(2){
        margin-right: 0.30rem;
    }

    @supports(object-fit: cover){
        .portada img{
          height: 100%;
          object-fit: cover;
          object-position: center center;
        }
    }

    .color{
        background-color: #B0E1DE;  
    }

    .content-categories{
        background-color: #B0E1DE;
        padding-top: 25px;
        padding-bottom: 25px;
        padding-left: 20px;
        padding-right: 20px;
        text-align: left;
        border-top-right-radius: 35px;
    }
    .content-categories h3{
        font-size: 27px;
        font-weight: 600;
        color: #fff;
    }
    .categorias{
        margin-top: 20px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
    }

    .categoria1{
        padding: 0;
        width: 48%;
        box-shadow: 0px 0px 4px 0px rgba(71,70,71,1);
        border-radius: 15px;
        flex-direction: column;
        margin-bottom: 15px;
        background-color: #fff;
    }

    .categoria1 img{
        width: 100%;
        height: auto;
        border-top-right-radius: 15px;
        border-top-left-radius: 15px;
    }

    .detalle-categoria{
        width: 100%;
        padding: 15px;
        text-align: center;
        background-color: #fff;
        border-bottom-right-radius: 15px;
        border-bottom-left-radius: 15px;
    }

    .detalle-categoria h3{
        font-family: 'Poppins', sans-serif;
        font-size: 18px;
        font-weight: 500;
        text-transform: capitalize;
    }

    /*input#buscar{ 
        font-family: FontAwesome, "Open Sans", Verdana, sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: inherit;
        border-radius: 15px;
        margin-top: 10px;
    }*/
</style>

<script>
	import Vue from 'vue';
	import axios from 'axios';
	import 'vuesax/dist/vuesax.css';
    import DetailCategory from './InternaCategory';
    import ProductDetail from './ProductDetail';
    import lazyload from '../directives/lazyload';
    import $ from 'jquery'
	let installEvent;
	export default {
	  props: ['form'],
      components: {
        DetailCategory,
        ProductDetail
      },
	  data() {
        return {
            url_images: localStorage.getItem('url_images'),  
            texto : "",
            showInstallBanner: false,
            category_selected : false,
            filter_option: JSON.parse(localStorage.getItem('filter_option')),
            id_companie: localStorage.getItem('id_companie'),
            product_list: [],
            product_list_aux: [],
            product_selected: false
        }
	  },
      directives:{
        lazyload
      },
      watch:{
        texto: function(value){
            console.log(value);

            //$(".content-categories").addClass("white");
            if (this.filter_option) {
                this.product_list_aux = [];
               $(".categorias").hide();
                $(".product-per-category").show();
                if (value == "") {
                    //$(".content-categories").removeClass("white");
                    $(".categorias").show();
                    $(".product-per-category").hide();
                } 
            }
            
        }
      },
	  methods:{
        Close(){    
            document.getElementById('pwa-ios-notify').style.display = 'none'; 
        }, 
        install() {
            this.showInstallBanner = false;
            installEvent.prompt();
            installEvent.userChoice.then(() => {
                installEvent = null;
            });
        },
        showDetail(category){
            this.apiConversionP();
            this.category_selected = category
        },
        saveApiConversion(uri,event,valor){
           let data={
            uri:uri,
            event:event,
            valor:valor
           }
           axios.post('https://back.vinapp.co/api/api-conversion',data)
           .then(res=>{
              console.log(res.data)
           }).catch(err=>{

           });
        }, 
        apiConversionP(){
         this.saveApiConversion(this.$route.params.id,'CustomizeProduct',0);
        },
        openDetail(product){
            this.product_selected = product;
        },
        search(){   
            this.product_list_aux = [];
            var texto = document.getElementById('buscar').value;
            if(texto.trim() != ""){
                if (!this.filter_option) {
                    this.form.categories.forEach((category) =>{  
                        if(!category.name.trim().toUpperCase().includes(texto.trim().toUpperCase())){
                            document.getElementById("card_"+category.id_category).style.display = "none";
                        }else{
                            document.getElementById("card_"+category.id_category).style.display = "";
                        }
                    });
                }else{
                    this.product_list.forEach((product) =>{  
                        if(product.name.trim().toUpperCase().includes(texto.trim().toUpperCase())){
                            //console.log(product.name.trim().toUpperCase()+"-"+texto.trim().toUpperCase())

                            this.product_list_aux.push(product);

                        }
                    });
                    this.product_list_aux = this.removeDuplicates(this.product_list_aux,'id');
                    
                }
                    
            }else{
                //cuando queda vacio el input search
                if (!this.filter_option) {
                    this.form.categories.forEach((category) =>{              
                      document.getElementById("card_"+category.id_category).style.display = "";
                    });
                }
                    
            }
        },
        removeDuplicates(originalArray, prop) {
             var newArray = [];
             var lookupObject  = {};

             for(var i in originalArray) {
                lookupObject[originalArray[i][prop]] = originalArray[i];
             }

             for(i in lookupObject) {
                 newArray.push(lookupObject[i]);
             }
              return newArray;
         },
        getAllProducts(){   
            var self = this;
            axios
            .get('https://back.vinapp.co/api/category/getOptimizedCategoriesEcommerce-2/'+this.id_companie)
            .then( res =>{
                self.product_list = res.data;
                console.log(self.product_list);
            })
            .catch( err => {
                console.log(err);
            });
        }
        /*openInternaCategory(id_category){
            let products = [];
            this.categories.forEach((category) =>{              
                if(category.id_category == id_category){
                    products.push(category.products);
                    this.$router.push({ name: 'InternaCategory', params: { products: products, id_category: id_category, name: category.name, company: this.form.company, store : this.form.store, id: this.form.uri }})
                }
            });
        }*/
	  },
	  mounted() {
        $(".product-per-category").hide();
        if (this.filter_option) {
            this.getAllProducts();
        }
        setTimeout(function(){
          $(".carousel-inner .carousel-item:nth-child(1)").addClass("active");
        },2000);
        //$('#banner').zoom();        
        window.addEventListener('beforeinstallprompt', e => {
          e.preventDefault();
          installEvent = e;
          this.showInstallBanner = true;
        });
         // Detects if device is on iOS 
          const isIos = () => {
          const userAgent = window.navigator.userAgent.toLowerCase();      
            return /iphone|ipad|ipod/.test( userAgent );
          } 
          const isFacebookApp = ()  => {
              const ua = navigator.userAgent || navigator.vendor || window.opera;
              return (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1);
          }
          // Detects if device is in standalone mode
          const isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone);
          // Checks if should display install popup notification:
          if (isIos() && !isInStandaloneMode()){
            if(!navigator.userAgent.includes("Instagram") && !isFacebookApp()){
              document.getElementById('pwa-ios-notify').style.display = 'block'; 
              document.getElementById('pwa-ios-notify').style.zIndex = "3" ;
              //setTimeout(function(){ document.getElementById('pwa-ios-notify').style.display = 'none'; }, 15000);
            }
          } 
	  }
	}
</script>
